import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QualDeveloperComponent } from './qual-developer/qual-developer.component';
import { TypeaheadModule } from '@components/typeahead/typeahead.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClassificationTypeaheadComponent as ClassificationTypeaheadComponent } from './classification-typeahead/classification-typeahead.component';
import { RangeInputComponent } from './range-input/range-input.component';
import { CaseIdTypeaheadComponent } from './caseid/caseid-typeahead.component';
import { StandardTypeaheadComponent } from './standard-typeahead/standard-typeahead.component';
import { MicroCredentialTypeaheadComponent } from './micro-credential-typeahead/micro-credential-typeahead.component';
import { QualificationTypeaheadComponent } from './qualification-typeahead/qualification-typeahead.component';
import { PublishToWebComponent } from './publish-to-web/publish-to-web.component';
import { SharedModule } from '@shared/shared.module';
import { FormComponentsModule } from '@shared/components/form-components/form-components.module';

@NgModule({
  declarations: [
    QualDeveloperComponent,
    ClassificationTypeaheadComponent,
    RangeInputComponent,
    CaseIdTypeaheadComponent,
    StandardTypeaheadComponent,
    MicroCredentialTypeaheadComponent,
    QualificationTypeaheadComponent,
    PublishToWebComponent
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TypeaheadModule, SharedModule, FormComponentsModule],
  exports: [
    QualDeveloperComponent,
    ClassificationTypeaheadComponent,
    RangeInputComponent,
    CaseIdTypeaheadComponent,
    StandardTypeaheadComponent,
    QualificationTypeaheadComponent,
    PublishToWebComponent
  ]
})
export class FormComponentsQcrModule {}
